export default __webpack_public_path__ + "static/media/wordpress.e9fe30bf.svg";